module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-16@2x-09094a4d2dc9bc3b687ef30a7121b3a9.png";